module.exports = __webpack_public_path__ + "static/media/2021bw.45576ae7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021bw.jpg
// module id = 802
// module chunks = 0